module.exports = __webpack_public_path__ + "media/images/recruit/credo/img-mantle-sp-8ad31b67285732e822acff9f00554f43.svg";